export const Service = Symbol('service');
export const Navigator = Symbol('navigator');
